const stateDefault =  {};

export default (state = stateDefault, action) => {
  switch (action.type){
    case 'SET_TEMP_FAV_MENU':
      let newState = {...state};
      newState[action.menuId] = action.isFavorite;
      return newState;
    default:
      return state;
  }
};
